import { useEffect } from "react";
import { useQuery } from "react-query";
import styled from "styled-components";

import { TailSpin } from "react-loader-spinner";
import { useTranslation } from "react-i18next";
import InnerPageLayout from "../Components/Layout/InnerPageLayout";
import { useParams } from "react-router-dom";
import { Accordion, Card } from "react-bootstrap";
import { getInternalPortalFaqs, getInternalPortalFaqsSection } from "../api/api";
import ReactMarkdown from "react-markdown";
import { IFaqItem } from "../types/faq";

interface IProps {
  id?: string;
}

const FaqsPage = (props: IProps) => {
  let { id, category } = useParams();


  const { t, i18n } = useTranslation();

  const { isLoading: isFaqLoading, error: faqError, data: faqData, refetch: refetchFaqs } = useQuery(
    "faqQuestionsData",
    () => getInternalPortalFaqs({ subCategory: id || "1", language: "ar" })
  );

  const { isLoading: isCategoryLoading, error: categoryError, data: categoryData } = useQuery(
    ["faqCategoryData", id],
    () => getInternalPortalFaqsSection({ subCategory: id || "1", language: "ar"  })
  );

  useEffect(() => {
    refetchFaqs();
  }, [i18n.language, refetchFaqs]);

  if (isFaqLoading || isCategoryLoading)
    return (
      <InnerPageLayout>
        <LoaderContainer>
          <TailSpin color="#ffffff" height={70} width={70} />
        </LoaderContainer>
      </InnerPageLayout>
    );

  if (faqError || categoryError)
    return (
      <InnerPageLayout>
        <div></div>
      </InnerPageLayout>
    );


    if (categoryData && categoryData.data && categoryData.data[0] && i18n.language === "en") {
      const localizations = categoryData.data[0].attributes.localizations.data;
      const enLocalization = localizations.find((loc: any) => loc.attributes.locale === "en");
  
      if (enLocalization) {
       categoryData.data[0].attributes.Title = enLocalization.attributes.Title;
      }
    }

    const localizedFaqData = faqData.data.map((faqItem: IFaqItem) => {
      if (i18n.language === "en") {
        const localizations = faqItem.attributes?.localizations?.data;
        const enLocalization = localizations?.find((loc: any) => loc.attributes.locale === "en");
  
        if (enLocalization) {
          return {
            ...faqItem,
            attributes: {
              ...faqItem.attributes,
              Title: enLocalization.attributes.Title,
              Description: enLocalization.attributes.Description,
            },
          };
        }
      }
      return faqItem;
    });

  return (
    <InnerPageLayout>
      <>
        <Card className="mb-4">
          <Card.Header>{t('faq_category')} - {categoryData?.data[0]?.attributes?.Title}</Card.Header>
          <Card.Body>
            <Accordion defaultActiveKey="0">
              {localizedFaqData.map((faqRow: IFaqItem, index: any) => (
                <Accordion.Item eventKey={index}>
                  <Accordion.Header>{faqRow.attributes.Title}</Accordion.Header>
                  <Accordion.Body>
                    <ReactMarkdown>{faqRow.attributes.Description}</ReactMarkdown>
                  </Accordion.Body>
                </Accordion.Item>
              ))}
            </Accordion>
          </Card.Body>
        </Card>
      </>
    </InnerPageLayout>
  );
};

const LoaderContainer = styled.div`
  min-height: 60vh;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export default FaqsPage;
